import Queries from 'queries';
import { graphql } from 'react-apollo';
import { getAuthQueryVariables } from 'helpers/Utils';

export const withCreateAccount = graphql(Queries.CreateAccount, {
  name: 'createAccountMutation',
});

export const withLogin = graphql(Queries.Login, {
  name: 'loginMutation',
});

export const withLogout = graphql(Queries.logout, {
  name: 'logoutMutation',
});

export const withMFARegistration = graphql(Queries.mfaRegistration, {
  name: 'mfaRegistrationMutation',
});

export const withMFAEmailRegistration = graphql(Queries.mfaEmailRegistration, {
  name: 'mfaEmailRegistrationMutation',
});

export const withEmailRegistration = graphql(Queries.emailRegistration, {
  name: 'emailRegistrationMutation',
});

export const withMFAVerification = graphql(Queries.mfaVerification, {
  name: 'mfaVerificationMutation',
});

export const withProcessDowntime = graphql(Queries.processDowntime, {
  name: 'processDowntime',
});

export const withMFAActivation = graphql(Queries.mfaActivation, {
  name: 'mfaActivationMutation',
});

export const withMFAResend = graphql(Queries.mfaResend, {
  name: 'mfaResendMutation',
});

export const withContinuePasswordReset = graphql(Queries.continuePasswordReset, {
  name: 'continuePasswordResetMutation',
});

export const withSetNewPassword = graphql(Queries.setNewPassword, {
  name: 'setNewPasswordMutation',
});

export const withRequestPasswordReset = graphql(Queries.requestPasswordReset, {
  name: 'requestPasswordResetMutation',
});

export const withUpdateCustomer = graphql(Queries.updateCustomer, {
  name: 'updateCustomerMutation',
});

export const withRedeemSubmission = graphql(Queries.redeemSubmission, {
  name: 'redeemSubmissionMutation',
});

export const withAddNewsletterSubscription = graphql(Queries.AddNewsletterSubscription, {
  name: 'addNewsletterSubscription',
});

export const withQuizSubmission = graphql(Queries.submitQuiz, {
  name: 'submitQuizMutation',
});

export const withDashboardPage = graphql(Queries.GetDashboardPage, {
  name: 'dashboardQuery',
  options: ({
    match: { params },
    defaultLanguage,
    localisation,
    contentstackKeys,
  }) => {
    const language = params?.language || defaultLanguage;
    const { imageAndLink, staticTextKeys, componentConfig } = contentstackKeys;

    return {
      variables: {
        language: localisation[language],
        ...getAuthQueryVariables({
          contentstackKeys,

          initailStaticTextKeys: [
            ...staticTextKeys.dashboard,
            ...staticTextKeys.dashboardDesktopMenuBar,
          ],
          initialImages: imageAndLink.dashboard,
          initialComponentConfig: componentConfig.dashboard,
        }),
      },
    };
  },
});

export const withLoginPage = graphql(Queries.GetLoginPage, {
  name: 'loginQuery',
  options: ({
    defaultLanguage,
    localisation,
    contentstackKeys,
    match: { params },
  }) => {
    const language = params?.language || defaultLanguage;

    return {
      variables: {
        language: localisation[language],
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: [],
          initialImages: [],
        }),
      },
    };
  },
});

export const withLoginLandingPage = graphql(Queries.GetLoginLandingPage, {
  name: 'loginLandingQuery',
  options: ({
    defaultLanguage,
    localisation,
    contentstackKeys,
    match: { params },
  }) => {
    const language = params?.language || defaultLanguage;
    const {
      imageAndLink, staticTextKeys, textBlockList, missionStatement,
    } = contentstackKeys;

    return {
      variables: {
        language: localisation[language],
        missionStatement: missionStatement.loginLanding,
        ...textBlockList.loginLanding,
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: staticTextKeys.loginLanding,
          initialImages: imageAndLink.loginLanding,
        }),
      },
    };
  },
});

export const withDashboardWhitepaperPage = graphql(Queries.GetStaticPage, {
  name: 'dashboardWhitepaperPage',
  options: ({
    defaultLanguage,
    localisation,
    contentstackKeys,
    match: { params },
  }) => {
    const language = params?.language || defaultLanguage;
    const { componentConfig, staticTextKeys } = contentstackKeys;

    return {
      variables: {
        language: localisation[language],
        product: 'dashboardWhitepaper',
        ...getAuthQueryVariables({
          initailStaticTextKeys: [
            ...staticTextKeys.dashboard,
            ...staticTextKeys.dashboardDesktopMenuBar,
            ...staticTextKeys.accountMenu,
          ],
          initialComponentConfig: componentConfig.accountMenu,
          contentstackKeys,
        }),
      },
    };
  },
});

export const getDashboardProfileQueryVariables = ({
  localisation,
  contentstackKeys,
  defaultLanguage,
  match: { params },
}) => {
  const language = params?.language || defaultLanguage;
  const { imageAndLink, staticTextKeys } = contentstackKeys;

  return {
    language: localisation[language],
    ...getAuthQueryVariables({
      contentstackKeys,
      initailStaticTextKeys: [
        ...staticTextKeys.dashboardProfile,
        ...staticTextKeys.dashboardDesktopMenuBar,
      ],
      initialImages: imageAndLink.dashboardProfile,
    }),
  };
};

export const withDashboardProfilePage = graphql(Queries.GetDashboardProfile, {
  name: 'dashboardQueryProfile',
  options: (props) => ({
    variables: getDashboardProfileQueryVariables(props),
  }),
});

export const withDashboardSettingsPage = graphql(Queries.GetDashboardSettingsPage, {
  name: 'dashboardSettingsQuery',
  options: ({
    match: { params },
    defaultLanguage,
    localisation,
    contentstackKeys,
  }) => {
    const language = params?.language || defaultLanguage;
    const { imageAndLink, staticTextKeys } = contentstackKeys;

    return {
      variables: {
        language: localisation[language],
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: [
            ...staticTextKeys.dashboardSettings,
            ...staticTextKeys.dashboardDesktopMenuBar,
          ],
          initialImages: imageAndLink.dashboardSettings,
        }),
      },
    };
  },
});

export const withRegisterReward = graphql(Queries.registerReward, {
  name: 'registerRewardQuery',
});

export const withRedeemReward = graphql(Queries.redeemReward, {
  name: 'redeemRewardQuery',
});

export const withForgotPasswordPage = graphql(Queries.GetForgotPasswordPage, {
  name: 'forgotPasswordPageQuery',
  options: ({
    match: { params },
    defaultLanguage,
    localisation,
    contentstackKeys,
  }) => {
    const language = params?.language || defaultLanguage;
    const { imageAndLink, staticTextKeys } = contentstackKeys;

    return {
      variables: {
        language: localisation[language],
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: staticTextKeys.forgotPassword,
          initialImages: imageAndLink.forgotPassword,
        }),
      },
    };
  },
});

export const withLandingPage = (product, landingPageTitle) => graphql(Queries.GetLandingPage, {
  name: 'landingPageQuery',
  options: ({
    defaultLanguage,
    localisation,
    contentstackKeys,
    match: { params },
  }) => {
    const language = params?.language || defaultLanguage;
    const { componentConfig, staticTextKeys } = contentstackKeys;

    return {
      variables: {
        language: localisation[language],
        product,
        ...getAuthQueryVariables({
          initailStaticTextKeys: [
            ...staticTextKeys.dashboard,
            ...staticTextKeys.dashboardDesktopMenuBar,
            ...staticTextKeys.accountMenu,
            ...staticTextKeys.weeklyEmailLandingPage,
          ],
          initialComponentConfig: [
            ...componentConfig.accountMenu,
            ...componentConfig.weeklyEmailLandingPage,
          ],
          contentstackKeys,
        }),
        landingPageTitle,
      },
    };
  },
});
